<!--<div class="card mb-3">-->
<!--  <div class="card-body row justify-content-between align-items-center">-->
<!--    <div class="col-md-6 d-flex flex-column form-group">-->
<!--      <span class="font-weight-light" *ngIf="order?.products">{{order.products[0].name}}</span>-->
<!--      <span>ID: <a class="font-weight-bold" (click)="goToTrack(order.deliveryId)"-->
<!--          *ngIf="order?.products">{{order.deliveryId}}</a>-->
<!--        <a class="font-weight-bold" *ngIf="!order?.products">{{order.deliveryId}}</a>-->
<!--      </span>-->
<!--      <label class="form-check-label" *ngIf="order.status">-->
<!--        <i class="fas fa-circle text-green"></i>-->
<!--        {{'enums.delivery-status.'+deliveryStatusEnum[order.status] | translate}}-->
<!--      </label>-->
<!--      <span class="text-danger" *ngIf="!order?.products">{{'public.tracking.find-orders.no-data'|translate}}</span>-->
<!--    </div>-->
<!--    <div class="col-md-5 d-flex flex-column" *ngIf="order.carrier">-->
<!--      <small>{{order.carrier.name}}</small>-->
<!--      <small>{{translatePath+'arrives-between'|translate}}-->
<!--        {{order.estimatedDeliveryStart | date : 'fullDate'}} - -->
<!--        {{order.estimatedDeliveryEnd | date : 'fullDate'}}-->
<!--      </small>-->
<!--    </div>-->
<!--    <div class="col-md-1 strong" *ngIf="order.cost">-->
<!--      <span class="text-primary font-weight-bold">{{order.cost}} MDL</span>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<div class="pickup mr-auto ml-auto">
  <div  class="pickup-info d-flex align-items-center">
    <p class="pickup-info__txt col-md-4 d-flex align-items-center">
      <span class="pickup-info__txt--state d-flex justify-content-center align-items-center"><span>{{'enums.delivery-status.'+deliveryStatusEnum[order.status] | translate}}</span></span>
      <span class="pickup-info__txt--prd d-flex flex-column ml-3">
              <span class="mb-2 ml-3" *ngIf="order.products">{{order.products[0].name}}</span>
              <span class="font-weight-bold ml-3" *ngIf="order.products">ID: <a class="font-weight-bold" (click)="goToTrack(order.deliveryId)">{{order.deliveryId}}</a></span>
              <span *ngIf="!order?.products"> {{'public.tracking.find-orders.data' | translate}} {{order.deliveryId}}</span>
           </span>
    </p>

    <div class="date-info col-md-5 d-flex flex-column pl-5" *ngIf="order.carrier">
      <small>{{order.carrier.name}}</small>
      <small>{{translatePath+'arrives-between'|translate}}
        {{order.estimatedDeliveryStart | dateTranslate : 'fullDate'}}
        {{order.estimatedDeliveryEnd | dateTranslate : 'fullDate'}}
      </small>
    </div>
    <span class="text-danger" [ngClass]="{'err' : !order}" *ngIf="!order?.products">{{'public.tracking.find-orders.no-data'|translate}}</span>

    <div class="d-flex cost  strong justify-content-center align-self-center display" [ngClass]="{'col-2': order?.cost }">
      <span class="pickup-cost font-weight-bold w-100" *ngIf="order?.cost">{{order?.cost}} MDL</span>
    </div>

  </div>
</div>

<div *ngIf="!order">
  <div class="row mt-3">
    <p class="text-muted">{{ 'admin.sp.noContentText' | translate }}</p>
  </div>
</div>
